export default __webpack_public_path__ + "static/media/Catraca Bloqueada.5a20d8c9.svg";